import { Client } from "../api/Client";
import { useQuery } from "@tanstack/react-query";

export const useGetCooperationSubAreas = (
  countryId: number | undefined,
  languageId: number | undefined
) => {
  const client = new Client();
  return useQuery({
    queryKey: ["getCooperationSubAreas", countryId, languageId],
    queryFn: () => client.cooperationSubarea(countryId ?? 0, languageId ?? 0),
    staleTime: 1000 * 60 * 60,
  });
};
